<style>
  .layout.row {
    margin-bottom: 20px!important;
  }
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Свойства</h3>
          <v-btn
                  color="pink"
                  dark
                  small
                  fab
                  @click="editOpen()"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
                  color="blue"
                  dark
                  small
                  fab
                  @click="refresh()"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>        
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                            flat
                            solo
                            prepend-icon="search"
                            placeholder="Поиск"
                            v-model="search"
                            hide-details
                            class="hidden-sm-and-down"
              >
              </v-text-field>     
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                            :headers="complex.headers"
                            :search="search"
                            :items="propertyData"
                            :rows-per-page-items="[10,25,50,100]"
                            class="elevation-1"
                            item-key="id"
                            no-results-text="Нет результатов"
                            rows-per-page-text="На странице"
                            v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ dataTypeMap.get(props.item.dataType) ? dataTypeMap.get(props.item.dataType) : '--' }}</td>
                  <td>{{ props.item.isActive == true ? "Да": "Нет" }}</td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <!-- <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn> -->
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID свойства</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="ID свойства"
                                    v-model="modalData.id"
                                    readonly
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Наименование свойства</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="Наименование свойства"
                                    v-model="modalData.name"
                                    :rules="rules.required"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Внешний ключ свойства</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <span v-if="readonlyFields">{{modalData.code}}</span>
                            <v-text-field
                                    v-if="!readonlyFields"
                                    label="Внешний ключ свойства"
                                    v-model="modalData.code"
                                    :rules="rules.code"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Тип данных</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-select
                              v-model="modalData.dataType"
                              :items="dataTypeList"
                              label="Тип данных"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активно</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                              <v-switch v-model="modalData.isActive"></v-switch>
                          </v-flex>
                      </v-layout> 
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить свойство?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
    import colors from 'vuetify/es5/util/colors';

    export default {
        components: {
        },

        data() {
            return {
                modalData: {},
                oldModalData: {},
                editedIndex: {},
                valid: true,
                readonlyFields: true,
                openColorBox: false,
                colors,
                rules: {
                    required: [ v => !!v || 'Обязательное поле' ],
                    code: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
                        v => this.propertyData.filter(el => el.code === v).length === 0 || 'Такой ключ уже существует',
                    ],
                },
                search: '',
                popupRemove: {
                    isOpen: false
                },
                popupEdit: {
                    isOpen: false,
                    isEditing: false,
                },
                complex: {
                    selected: [],
                    headers: [
                        {
                            text: 'ID',
                            value: 'id'
                        },
                        {
                            text: 'Наименование',
                            value: 'name'
                        },
                        {
                            text: 'Внешний ключ',
                            value: 'code'
                        },
                        {
                           text: 'Тип данных',
                           value: 'dataType'
                        },
                        {
                            text: "Активно",
                            value: "isActive"
                        },
                        {
                            text: 'Действия',
                            value: ''
                        }
                    ],
                }
            };
        },

        mounted: function() {
          /**
           * Загружаем данные по свойствам при первой отрисовке страницы
           * Если propertyData не пустой, то не обновляемся
           */
          if (this.propertyData.length === 0) {
              this.refresh();
          }

          /**
           * Загружаем данные о типах данных, если они еще не загружались
           */
          if (this.$store.getters['dataType/dataTypeList'].length === 0) {
            this.$store._actions['dataType/getDataTypeList'][0]();
          }
        },

        computed: {
          /**
           * Данные по свойствам
           * @returns {default.computed.propertyData|(function())|Array|getters.propertyData}
           */
          propertyData() {
            return this.$store.getters['property/propertyData'];
          },

          /**
           * Список типов данных для Select'a
           * @returns {default.computed.dataTypeList|(function())|Array|getters.dataTypeList}
           */
          dataTypeList() {
            return this.$store.getters['dataType/dataTypeList'].map(dataType => {
              return {
                text: dataType.name,
                value: dataType.id
              };
            });
          },

          /**
           * Объект Map, содержащий пары "dataTypeId-dataTypeName"
           * @returns {default.computed.dataTypeMap|(function())|Array|getters.dataTypeList}
           */
          dataTypeMap() { 
            let result = new Map();

            this.$store.getters['dataType/dataTypeList'].forEach(dataType => {
              result.set(dataType.value, dataType.text);
            })

            return result;
          },
        },

        methods: {
            /**
             * Обновление данных по свойствам
             */
            refresh() {
              this.$store._actions['property/getPropertyData'][0]();
            },

            /**
             * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
             * @param item
             */
            editOpen(item) {
                // Если редактирование
                if (item !== null && typeof item !== 'undefined') {
                    this.modalData = item;
                    this.oldModalData = Object.assign({}, item);
                    this.editedIndex = this.propertyData.indexOf(item);
                    this.readonlyFields = true;
                    // Если добавление
                } else {
                    this.modalData = {
                        id: -1,
                        name: '',
                        code: '',          
                        dataType: null,   
                        isActive: false
                    };

                    this.oldModalData = {};
                    this.editedIndex = -1;
                    this.readonlyFields = false;
                }

                this.popupEdit.isOpen = true;
            },

            /**
             * Отмена редактирования
             */
            editCancel() {
              if (this.editedIndex != -1) {
                Object.assign(this.propertyData[this.editedIndex], this.oldModalData);
              }

              this.popupEdit.isOpen = false;
            },

            /**
             * Сохранение отредактированного элемента
             */
            submit() {
              if (this.$refs.form.validate()) {
                this.$store._actions['property/savePropertyData'][0]({index: this.editedIndex, data: this.modalData}).then(() => {
                  this.popupEdit.isOpen = false;
                })
              }
            },

            /**
             * Открытие модального окна с подтверждением удаления
             * @param data
             */
            removeItemConfirm(data) {
              this.popupRemove.isOpen = true;
              this.modalData = data;
            },

            /**
             * Удаление элемента
             * @param item
             */
            actionRemove(item) {
              this.$store._actions['property/removePropertyData'][0]({item: item});
              this.popupRemove.isOpen = false;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/Property.vue